<div class="rfq-setup-container" [ngClass]="{ hide: !showPanel() }">
  <div class="rfq-setup-container__collapse" (click)="showHideSetupMenu()">
    <span
      class="rfq-setup-container__collapse__arrow"
      [ngClass]="{
        'rfq-setup-container__collapse__arrow--closed': !showSetupMenu
      }"
    >
      &lt;
    </span>
  </div>
  <div
    class="rfq-setup-container__main"
    [inert]="!showSetupMenu"
    [@openClose]="showSetupMenu ? 'open' : 'closed'"
  >
    <div
      class="rfq-setup-content-container"
      [ngClass]="{
        'rfq-setup-content-container--sub-account-width': useBlockTrades
      }"
    >
      <div class="rfq-setup-content">
        <form
          [formGroup]="form"
          class="rfq-setup-content__form"
          autocomplete="off"
        >
          <span
            class="rfq-setup-content__row"
            *ngIf="useBlockTrades"
            [ngStyle]="{ order: displayOrder['isBlockTrade'] }"
          >
            <label class="rfq-setup-content__label"> Block Trade </label>
            <span class="select_container select_container--accounts">
              <app-selector
                formControlName="isBlockTrade"
                [placeholder]="'Select'"
                [passedItems]="['Yes', 'No']"
                [readonly]="rfqRunning"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <span
            class="rfq-setup-content__row"
            *ngIf="
              !isLegacyWhitelabel && !rfqTab.executionContext.hideSingleAccount
            "
            (click)="openSearchDialog()"
            [ngStyle]="{ order: displayOrder['account'] }"
          >
            <label
              class="rfq-setup-content__label"
              [ngClass]="{ pointer: hasDisplayNames }"
            >
              <span
                class="simple-tooltip simple-tooltip--left simple-tooltip--wide"
                [attr.data-tooltip]="getAccountTooltip()"
              >
                Account
                <cds-icon shape="info-circle" class="account"></cds-icon>
              </span>
            </label>
            <span class="select_container select_container--accounts">
              @if (hasDisplayNames) {
                <div class="account">
                  <div class="account-text">
                    {{ form.get('account').value }}
                  </div>
                  <span
                    class="simple-tooltip simple-tooltip--left account-search"
                    [attr.data-tooltip]="'Select account'"
                  >
                    <cds-icon
                      shape="search"
                      size="12"
                      *ngIf="!rfqRunning"
                    ></cds-icon>
                  </span>
                </div>
              } @else {
                <app-selector
                  formControlName="account"
                  [passedItems]="availableAccounts()"
                  [readonly]="rfqRunning || hasDisplayNames"
                  [isSearch]="true"
                  class="ng-selector-read-only-color-white"
                ></app-selector>
              }
            </span>
          </span>

          <ng-container *ngIf="form.get('subAccount')?.enabled">
            <span
              class="rfq-setup-content__row"
              [ngStyle]="{ order: displayOrder['subAccount'] }"
            >
              <label class="rfq-setup-content__label"> Sub Account </label>
              <span class="select_container select_container--sub-accounts">
                <app-selector
                  formControlName="subAccount"
                  [passedItems]="
                    subAccounts | arrayAttributeMap: 'Account Short Name'
                  "
                  [readonly]="rfqRunning"
                  [isSearch]="true"
                  class="ng-selector-read-only-color-white"
                ></app-selector>
              </span>
            </span>

            <span
              class="rfq-setup-content__row"
              *ngIf="subAccountSelected"
              [ngStyle]="{ order: displayOrder['accountCID'] }"
            >
              <label class="rfq-setup-content__label"> Account CID </label>
              <div
                class="select_container select_container--sub-account-account-cid"
              >
                {{ subAccountSelected['Account CID'] }}
              </div>
            </span>

            <span
              class="rfq-setup-content__row"
              *ngIf="subAccountSelected"
              [ngStyle]="{ order: displayOrder['cityLocation'] }"
            >
              <label class="rfq-setup-content__label"> City Location </label>
              <div
                class="select_container select_container--sub-account-account-cid"
              >
                {{ subAccountSelected['City Location'] }}
              </div>
            </span>
          </ng-container>

          <span
            class="rfq-setup-content__row"
            *ngIf="!isLegacyWhitelabel && primeBrokerVisible()"
            [ngStyle]="{ order: displayOrder['primeBroker'] }"
          >
            <label class="rfq-setup-content__label"> Prime Broker </label>
            <span class="select_container select_container--broker">
              <app-selector
                formControlName="primeBroker"
                [passedItems]="brokers"
                [readonly]="rfqRunning"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <ng-container *ngFor="let attribute of additionalRfqAttributes()">
            <span
              class="rfq-setup-content__row"
              [ngStyle]="{ order: displayOrder[attribute.shortName] }"
            >
              <span class="rfq-setup-content__label">
                {{ attribute.longName }}
              </span>

              @switch (attribute.type) {
                @case ('string') {
                  <span
                    class="select_container select_container--additional-attribute-string"
                  >
                    <input-with-spinner
                      [formControlName]="attribute.shortName"
                      [readOnly]="
                        attribute.readOnly ||
                        (rfqRunning && attribute.lockedOnSubmitRequest) ||
                        (showBookTrades &&
                          attribute.lockedOnBookTrade &&
                          bookingState !== 'BOOKED')
                      "
                      [useBasicTextBox]="true"
                    ></input-with-spinner>
                  </span>
                }
                @case ('enum') {
                  <span
                    class="select_container select_container--additional-attribute-enum"
                  >
                    <app-selector
                      [formControlName]="attribute.shortName"
                      [passedItems]="attribute.values || []"
                      [isSearch]="true"
                      class="ng-selector-read-only-color-white"
                      [readonly]="
                        attribute.readOnly ||
                        (rfqRunning && attribute.lockedOnSubmitRequest) ||
                        (showBookTrades &&
                          attribute.lockedOnBookTrade &&
                          bookingState !== 'BOOKED')
                      "
                    ></app-selector>
                  </span>
                }
                @case ('boolean') {
                  <span
                    class="additional-attribute-checkbox-container"
                    [ngClass]="{
                      'additional-attribute-checkbox-container--read-only':
                        attribute.readOnly ||
                        (rfqRunning && attribute.lockedOnSubmitRequest) ||
                        (showBookTrades &&
                          attribute.lockedOnBookTrade &&
                          bookingState !== 'BOOKED')
                    }"
                  >
                    <span
                      [inert]="
                        attribute.readOnly ||
                        (rfqRunning && attribute.lockedOnSubmitRequest) ||
                        (showBookTrades &&
                          attribute.lockedOnBookTrade &&
                          bookingState !== 'BOOKED')
                      "
                    >
                      <input
                        type="checkbox"
                        clrCheckbox
                        [formControlName]="attribute.shortName"
                      />
                    </span>
                  </span>
                }
              }
            </span>
          </ng-container>

          <span
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['premium'] }"
          >
            <label class="rfq-setup-content__label"> Premium </label>
            <span class="select_container select_container--premium">
              <app-selector
                formControlName="premium"
                [passedItems]="premium"
                [readonly]="ignoreReadOnly"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <span
            class="rfq-setup-content__row"
            *ngIf="form?.controls['premiumStyle']"
            [ngStyle]="{ order: displayOrder['premiumStyle'] }"
          >
            <label class="rfq-setup-content__label"> Premium Style </label>
            <span class="select_container select_container--premium-style">
              <app-selector
                formControlName="premiumStyle"
                [passedItems]="premiumStyles"
                [readonly]="ignoreReadOnly"
                (valueEmitter)="changeInPremiumStyle($event.userSelect)"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <span
            class="rfq-setup-content__row"
            *ngIf="form?.controls['indicativePremiumStyle']"
            [ngStyle]="{ order: displayOrder['indicativePremiumStyle'] }"
          >
            <label class="rfq-setup-content__label"> Premium Style </label>
            <span
              class="select_container select_container--indicative-premium-style"
            >
              <app-selector
                formControlName="indicativePremiumStyle"
                [passedItems]="whiteLabelPremiumStyles"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <span
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['premiumValue'] }"
          >
            <label class="rfq-setup-content__label"> Premium Value </label>
            <span class="select_container select_container--premium-value">
              <app-selector
                formControlName="premiumValue"
                [passedItems]="premiumValues()"
                [readonly]="rfqRunning"
                [textColor]="productTypesColor"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>

          <span
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['premiumDate'] }"
          >
            <label class="rfq-setup-content__label"> Date </label>
            <span class="select_container select_container--premium-date">
              <input-with-spinner
                formControlName="premiumDate"
                [textColor]="premiumDateColor"
                [readOnly]="true"
                [useBasicTextBox]="true"
              ></input-with-spinner>
            </span>
          </span>

          <div
            class="rfq-setup-content__row"
            [ngClass]="{ hide: !(enableMultipleHedges || enableSingleHedge) }"
            [ngStyle]="{ order: displayOrder['hedgeTitle'] }"
          >
            <label
              class="rfq-setup-content__label rfq-setup-content__label-hedge"
            >
              Hedge
            </label>
          </div>

          <div
            class="rfq-setup-content__row"
            [ngClass]="{
              hide:
                !enableMultipleHedges ||
                rfqTab.executionContext.executionTypes[0].shortName ===
                  'genericMultiHedge'
            }"
            [ngStyle]="{ order: displayOrder['hedgeMode'] }"
          >
            <label class="rfq-setup-content__label"> Mode </label>
            <div class="hedge-container">
              <span
                class="hedge-container__hedge"
                class="select_container select_container--hedge"
              >
                <app-selector
                  formControlName="hedgeMode"
                  [passedItems]="getHedgeModes()"
                  class="ng-selector-read-only-color-white"
                ></app-selector>
              </span>
            </div>
          </div>

          <div
            class="rfq-setup-content__row"
            [ngClass]="{
              hide:
                (enableMultipleHedges &&
                  rfqTab.executionContext.executionTypes[0].shortName !==
                    'genericMultiHedge') ||
                !enableSingleMedusaHedge
            }"
            [ngStyle]="{ order: displayOrder['hedge'] }"
          >
            <label class="rfq-setup-content__label"> Type </label>
            <div class="hedge-container">
              <span
                class="hedge-container__hedge"
                class="select_container select_container--hedge"
              >
                <app-selector
                  formControlName="hedge"
                  [passedItems]="hedges()"
                  [readonly]="rfqRunning || rfqTabService.traded"
                  class="ng-selector-read-only-color-white"
                ></app-selector>
              </span>
            </div>
          </div>

          <div
            class="rfq-setup-content__row"
            [ngClass]="{
              hide: !form?.controls['execution']?.enabled
            }"
            [ngStyle]="{ order: displayOrder['execution'] }"
          >
            <label class="rfq-setup-content__label"> Execution </label>

            <div class="rfq-setup-content__row__execution">
              <label
                class="rfq-setup-content__row__execution__label rfq-setup-content__row__execution__label--live"
                [ngClass]="{
                  'rfq-setup-content__row__execution__label--checked':
                    !execution.checked
                }"
                >Live</label
              >
              <input
                type="checkbox"
                clrToggle
                class="rfq-setup-content__row__toggle"
                #execution
                (change)="executionOnClick($any($event).target.checked)"
              />
              <label
                class="rfq-setup-content__row__execution__label"
                [ngClass]="{
                  'rfq-setup-content__row__execution__label--checked':
                    execution.checked
                }"
                >DX
              </label>
            </div>
          </div>

          <div
            *ngIf="
              rfqTab.executionContext.executionTypes[0]?.shortName ===
              'genericMultiHedge'
            "
            class="rfq-setup-content__row rfq-setup-content__row"
            [ngStyle]="{
              order: displayOrder['spotFwdRef']
            }"
          >
            @if (form.controls['hedgeRates']?.enabled) {
              <label class="rfq-setup-content__label">
                {{
                  form.controls['hedge'].value === 'Forward Hedge'
                    ? 'Fwd Ref'
                    : 'Spot Ref'
                }}
              </label>
            }
            <div class="rfq-setup-content__row__spot-ref">
              @if (form.controls['hedgeRates']?.enabled) {
                <app-two-way-spot
                  [indicesToHighlight]="pipsHighlightedIndices"
                  [contentEditable]="
                    form.controls['spotRefMethod'].value === 'custom'
                  "
                  [askName]="'hedgeRateAsk'"
                  [bidName]="'hedgeRateBid'"
                  [midName]="'hedgeRateMid'"
                  [form]="$any(form.controls['hedgeRates'])"
                  [incrementsScale]="true"
                  [twoWayMode]="form.controls['execution'].value === 'Live'"
                  (changeInValueBlur)="
                    submitSetupEventGenericMultiHedge('hedgeRate')
                  "
                ></app-two-way-spot>
              }

              <div
                class="btn-group"
                *ngIf="form.controls['spotRefMethod']?.enabled"
              >
                <div class="radio btn">
                  <input
                    type="radio"
                    name="spotRefMethod"
                    id="spotRefStream-{{ uniqRfqId }}"
                    #streamSpotRef
                    value="stream"
                    formControlName="spotRefMethod"
                    checked
                  />
                  <label for="spotRefStream-{{ uniqRfqId }}">Stream</label>
                </div>
                <div class="radio btn">
                  <input
                    type="radio"
                    name="spotRefMethod"
                    id="spotRefCustom-{{ uniqRfqId }}"
                    formControlName="spotRefMethod"
                    value="custom"
                  />
                  <label for="spotRefCustom-{{ uniqRfqId }}">Custom</label>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              rfqTab.executionContext.executionTypes[0]?.shortName ===
                'genericMultiHedge' &&
              (form.controls['hedge'].value === 'Spot Hedge' ||
                (form.controls['hedge'].value === 'Forward Hedge' &&
                  uniqueSettlementDates?.length === 1))
            "
            class="rfq-setup-content__row rfq-setup-content__row--market-rates"
            [ngStyle]="{
              order: displayOrder['marketRate']
            }"
          >
            @if (form.controls['spotRefMethod'].value === 'custom') {
              <label class="rfq-setup-content__label"> Market </label>
              <div class="market-rate-container" *ngIf="marketRates">
                <div class="market-rate-container__bid">
                  <app-number-highlighter
                    [startAfterDecimal]="true"
                    [value]="
                      form.controls['hedge'].value === 'Spot Hedge'
                        ? marketRates.spotRates.bid
                        : marketRates.forwardRates[0].bid
                    "
                    [indicesToHighlight]="pipsHighlightedIndices"
                  ></app-number-highlighter>
                </div>
                <span
                  *ngIf="
                    form.controls['hedge'].value === 'Spot Hedge'
                      ? marketRates.spotRates.bid
                      : marketRates.forwardRates[0].bid
                  "
                  >/</span
                >
                <div class="market-rate-container__ask">
                  <app-number-highlighter
                    [startAfterDecimal]="true"
                    [value]="
                      form.controls['hedge'].value === 'Spot Hedge'
                        ? marketRates.spotRates.ask
                        : marketRates.forwardRates[0].ask
                    "
                    [indicesToHighlight]="pipsHighlightedIndices"
                  ></app-number-highlighter>
                </div>
              </div>
            }
          </div>

          <div
            class="rfq-setup-content__row"
            [ngClass]="{ hide: !enableCustomHedgeAmount }"
            [ngStyle]="{ order: displayOrder['hedgeCustomAmount'] }"
          >
            <label class="rfq-setup-content__label"> Custom Amount </label>
            <div class="hedge-container">
              <span
                class="hedge-container__hedge"
                class="select_container select_container--hedge"
              >
                <input
                  class="clr-input rfq-setup-input"
                  type="text"
                  [inputValidator]="['numericShorthand']"
                  formControlName="hedgeCustomAmount"
                  [readonly]="!canUpdateHedgeCustomValue()"
                  (blur)="submitSetupEvent('hedgeCustomAmount')"
                />
              </span>
            </div>
          </div>

          <span
            class="rfq-setup-content__row"
            [ngClass]="{
              hide: !form?.controls['hedgeRate'].enabled || !enableSingleHedge
            }"
            [ngStyle]="{ order: displayOrder['hedgeRate'] }"
          >
            <label class="rfq-setup-content__label"> Rate </label>
            <span>
              <input
                class="clr-input rfq-setup-input"
                type="number"
                formControlName="hedgeRate"
                [readonly]="rfqRunning"
              />
            </span>
          </span>

          <div
            *ngIf="
              form?.controls['hedgeRates']?.enabled &&
              rfqTab.executionContext.enableTwoWayCustomHedgeRateForNonDx
            "
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['hedgeRates'] }"
          >
            <label class="rfq-setup-content__label">Rates</label>
            <span class="hedge-rates-row" formGroupName="hedgeRates">
              <input-with-spinner
                class="hedge-rates-row__input"
                formControlName="hedgeRateBid"
                (onBlur)="hedgeRatesBlur('hedgeRateBid')"
                [readOnly]="!canUpdateHedgeCustomValue()"
                [inputValidator]="['numericShorthand']"
              ></input-with-spinner>
              <span> / </span>
              <input-with-spinner
                class="hedge-rates-row__input"
                formControlName="hedgeRateAsk"
                (onBlur)="hedgeRatesBlur('hedgeRateAsk')"
                [readOnly]="!canUpdateHedgeCustomValue()"
                [inputValidator]="['numericShorthand']"
              ></input-with-spinner>
            </span>
          </div>

          <span
            *ngIf="isHedgeCustomAndVolBased"
            class="rfq-setup-content__row rfq-setup-content__row--hedge-extra rfq-setup-content__row--hedge-amount"
            [ngStyle]="{ order: displayOrder['hedgeAmount'] }"
          >
            <label class="rfq-setup-content__label"> Amount </label>
            <span>
              <input
                class="clr-input rfq-setup-input"
                type="text"
                formControlName="hedgeAmount"
                [readonly]="rfqRunning"
                [inputValidator]="['numericShorthand']"
              />
            </span>
            <span class="rfq-setup-content__row--hedge-amount-ccy">{{
              currencyPair.base
            }}</span>
          </span>
          <span
            *ngIf="isHedgeCustomAndVolBased"
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['hedgeDirection'] }"
          >
            <label class="rfq-setup-content__label"> Direction (offer) </label>
            <span class="select_container select_container--premium-value">
              <app-selector
                [passedItems]="['Buy', 'Sell']"
                [readonly]="rfqRunning"
                formControlName="hedgeDirection"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>
          <span
            *ngIf="isHedgeCustomAndVolBased"
            class="rfq-setup-content__row"
            [ngStyle]="{ order: displayOrder['hedgeDirectionBid'] }"
          >
            <label class="rfq-setup-content__label"> Direction (bid) </label>
            <span class="select_container select_container--premium-value">
              <app-selector
                [passedItems]="['Buy', 'Sell']"
                [readonly]="rfqRunning"
                formControlName="hedgeDirectionBid"
                class="ng-selector-read-only-color-white"
              ></app-selector>
            </span>
          </span>
          <div
            class="banks-row"
            *ngIf="!isLegacyWhitelabel"
            [ngStyle]="{ order: displayOrder['banks'] }"
          >
            <app-banks-selector
              #bankSelector
              formControlName="banks"
              [selectedBankStates]="selectedBanksState"
              [availableBanks]="providers"
              [readonly]="rfqRunning"
              [availableSubstitutes]="availableSubstitutesShortNames"
              (communicationLine)="bankSelectorResponse($event)"
            ></app-banks-selector>
          </div>
          <div [ngStyle]="{ order: displayOrder['spots'] }">
            <ng-container *ngTemplateOutlet="spotsTmpl" />
          </div>
          <div [ngStyle]="{ order: displayOrder['spots'] }">
            <ng-container *ngTemplateOutlet="indicativeSpotsTmpl" />
          </div>
          <div [ngStyle]="{ order: displayOrder['spots'] }">
            <ng-container *ngTemplateOutlet="soleProviderSpotTmpl" />
          </div>
          <div
            *ngIf="enableComplianceChecks"
            class="rfq-setup-content__row rfq-setup-content__row--mifid-checks"
            [ngStyle]="{ order: displayOrder['mifidChecks'] }"
          >
            <app-mifid-checks></app-mifid-checks>
          </div>
        </form>
      </div>
    </div>

    <ng-container
      *ngIf="
        accountSet &&
        enableMultipleHedges &&
        form.get('hedgeMode').value !== 'None'
      "
    >
      <app-rfq-multi-hedge-group
        [ngClass]="{ hide: hideMultipleHedges }"
        [groupName]="
          form.get('hedgeMode').value === 'Live' ? 'Desk' : accountSet
        "
        [hedgeMode]="form.get('hedgeMode').value"
        [currencyPair]="currencyPair"
        [premiumCcy]="form.get('premium').value"
        [premiumDate]="form.get('premiumDate').value"
        [hedgeSetupValue]="form.get('hedge').value"
        [firstLegSettlementDate]="settlementDateOfFirstLeg"
        [legSettlementDates]="legSettlementDates"
        [legExpiryDates]="legExpiryDates"
        [presetHedges]="rfqTab.presetSetupData?.hedges"
        [blockVolBasedPriceHedgeChanges]="blockVolBasedPriceHedgeChanges"
        [pipsHighlightedIndices]="pipsHighlightedIndices"
        [marketRates]="marketRates"
        [hedgeQuote]="latestHedgeQuote"
        (onHedgeChange)="onHedgesChange($event)"
        #hedges
      ></app-rfq-multi-hedge-group>
    </ng-container>
  </div>
</div>

<div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

<ng-template #indicativeSpotsTmpl>
  <div
    *ngIf="
      displayIndicativeSpot && (indicativeSpots.bid || indicativeSpots.ask)
    "
    class="rfq-setup-content__row indicative-spots-row"
  >
    <label class="rfq-setup-content__label indicative-spots-row__title">
      Indicative Spot
    </label>
    <div class="indicative-spots-row__values">
      <div
        class="indicative-spots-row__values__container"
        [@valueIncreaseDecreasebg]="indicativeSpots.bid"
        [@.disabled]="!indicativeSpots.flashOnChange"
      >
        <app-number-highlighter
          [startAfterDecimal]="true"
          [value]="indicativeSpots.bid"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
      </div>
      <span class="divider">/</span>
      <div
        class="indicative-spots-row__values__container"
        [@valueIncreaseDecreasebg]="indicativeSpots.ask"
        [@.disabled]="!indicativeSpots.flashOnChange"
      >
        <app-number-highlighter
          [startAfterDecimal]="true"
          [value]="indicativeSpots.ask"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #soleProviderSpotTmpl>
  <div
    class="rfq-setup-content__row indicative-spots-row"
    *ngIf="showSoleProviderSpot"
  >
    <label class="rfq-setup-content__label indicative-spots-row__title">
      Provider Spot
    </label>
    <div class="indicative-spots-row__values">
      <div
        class="indicative-spots-row__values__container"
        [@valueIncreaseDecreasebg]="soleProviderSpot.bid"
      >
        <ng-container
          *ngTemplateOutlet="
            providerSpotWrapperTmpl;
            context: {
              spot: soleProviderSpot.bid
            }
          "
        ></ng-container>
      </div>
      <span class="divider">/</span>
      <div
        class="indicative-spots-row__values__container"
        [@valueIncreaseDecreasebg]="soleProviderSpot.ask"
      >
        <ng-container
          *ngTemplateOutlet="
            providerSpotWrapperTmpl;
            context: {
              spot: soleProviderSpot.ask
            }
          "
        ></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #providerSpotWrapperTmpl let-spot="spot">
  <span>
    @if (spot) {
      <app-number-highlighter
        [startAfterDecimal]="true"
        [value]="spot"
        [indicesToHighlight]="pipsHighlightedIndices"
      ></app-number-highlighter>
    } @else {
      pending
    }
  </span>
</ng-template>

<ng-template #spotsTmpl>
  <form [formGroup]="form">
    <ng-container *ngIf="form?.controls['spots']">
      <div class="rfq-setup-content__row">
        <label class="rfq-setup-content__label rfq-setup-content__label-hedge">
          Market Spot
        </label>
      </div>

      <span class="spots-row" formGroupName="spots">
        <span> </span>
        <input-with-spinner
          class="spots-row__input {{ hedgeMode }}"
          formControlName="spotBid"
          [className]="'spotBid'"
          [textColor]="liveSpotColors.spotBid.current"
          (inputChange)="spotFieldEdited('spotBid')"
        ></input-with-spinner>
        <span> / </span>
        <input-with-spinner
          class="spots-row__input {{ hedgeMode }}"
          [className]="'spotAsk'"
          formControlName="spotAsk"
          [textColor]="liveSpotColors.spotAsk.current"
          (inputChange)="spotFieldEdited('spotAsk')"
        ></input-with-spinner>
        <span class="spots-row__refresh-container" (click)="getLatestSpots()">
          <cds-icon shape="refresh" size="12"></cds-icon>
        </span>
      </span>
    </ng-container>
  </form>
</ng-template>

<dialog #dialog>
  <div class="search">
    <input
      clrInput
      type="text"
      class="search__input"
      placeholder="Search accounts"
      (keyup)="filter(search.value)"
      autocomplete="off"
      spellcheck="false"
      #search
    />
  </div>
  <div class="table-wrapper scrollable-content">
    @if (filteredEntities.length === 0 && accountSearchState == null) {
      <div class="loading">No results</div>
    } @else if (accountSearchState === 'TOO_SHORT') {
      <div class="loading">
        {{ allEntities.length }} accounts found. Enter at least 3 characters to
        search.
      </div>
    } @else {
      @if (accountSearchState === 'TOO_MANY_RESULTS') {
        <div class="loading">
          Too many matches - not all results are shown. Please refine the search
        </div>
      }
      <table class="table">
        <thead>
          <tr>
            <th [ngStyle]="{ width: identifierWidth }">Identifier</th>
            <th [ngStyle]="{ width: shortDisplayNameWidth }">Short name</th>
            <th>Long name</th>
          </tr>
        </thead>
        <tbody>
          @for (e of filteredEntities; track e.identifier) {
            <tr (click)="selectAccount(e)">
              <td [ngStyle]="{ width: identifierWidth }">
                {{ e.displayedIdentifier || e.identifier }}
              </td>
              <td [ngStyle]="{ width: shortDisplayNameWidth }">
                {{ e.shortDisplayName }}
              </td>
              <td>{{ e.displayName }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
  <form method="dialog">
    <button value="cancel" formmethod="dialog">Close</button>
  </form>
</dialog>
